import axios from 'axios'
import {SLOW_REQUEST_CONFIG, SLOW_REQUEST_HEADER} from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export const CADASTRAR_CONFIGURACAO_BPE = '@configuraBPeAction/CADASTRAR_CONFIGURACAO_BPE';
export const ALTERAR_CONFIGURACAO_BPE = '@configuraBPeAction/ALTERAR_CONFIGURACAO_BPE';
export const BUSCAR_CONFIGURACOES_BPE = '@configuraBPeAction/BUSCAR_CONFIGURACOES_BPE';
export const ATIVAR_CONFIGURACAO_BPE = '@configuraBPeAction/ATIVAR_CONFIGURACAO_BPE';
export const DESATIVAR_CONFIGURACAO_BPE = '@configuraBPeAction/DESATIVAR_CONFIGURACAO_BPE';
export const IMPORTAR_CONFIGURACAO_BPE = '@configuraBPeAction/IMPORTAR_CONFIGURACAO_BPE';
export const EXCLUIR_CONFIGURACAO_BPE = '@configuraBPeAction/EXCLUIR_CONFIGURACAO_BPE';

export function importarConfiguracaoBPe (codigoEmpresaOrigem, codigoEmpresaDestino ) {
  const url = `${URL}/configuracao-bpe/empresa-origem/${codigoEmpresaOrigem}/empresa-destino/${codigoEmpresaDestino}/importar`;
  return dispatch => axios.get(url,SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: IMPORTAR_CONFIGURACAO_BPE,
        payload: response
      })
  );
}

export function alterarConfiguracaoBPe(configuracao) {
  const url = `${URL}/configuracao-bpe/alterar`;
  
  return dispatch => axios.post(url, configuracao, {
    headers: {
      'Content-Type': 'multipart/mixed',
      [SLOW_REQUEST_HEADER]: true
    }
  }).then(
    response => dispatch({
      type: ALTERAR_CONFIGURACAO_BPE,
      payload: response
    })
  );
}

export function ativarConfiguracaoBpe(codigo) {
  const url = `${URL}/configuracao-bpe/${codigo}/ativar`;
  
  
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ATIVAR_CONFIGURACAO_BPE,
      payload: response
    })
  );
}

export function desativarConfiguracaoBpe(codigo) {
  const url = `${URL}/configuracao-bpe/${codigo}/desativar`;
  
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: DESATIVAR_CONFIGURACAO_BPE,
      payload: response
    })
  );
}


export function buscarConfiguracoesBPe (codigoEmpresa) {
  const url = `${URL}/configuracao-bpe/empresa/${codigoEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_CONFIGURACOES_BPE,
      payload: response
      
    })
  );
}

export function cadastrarConfiguracaoBPe (configuracao) {
  const url = `${URL}/configuracao-bpe/cadastrar`;
  return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CADASTRAR_CONFIGURACAO_BPE,
      payload: response
    })
  );
}

export function excluirConfiguracaoBPe (id) {
  const url = `${URL}/configuracao-bpe/${id}/excluir`;
  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: EXCLUIR_CONFIGURACAO_BPE,
      payload: response
    })
  );
}


